/* tslint:disable */
/* eslint-disable */
/**
 * ROC API
 * Referral Outbound Center (ROC) API for managing outbound referrals between post-acute care facilities.  All endpoints require a valid JWT. Organization and user identity are derived from the token — callers never pass these in query params or request bodies. 
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RecipientStatus } from './RecipientStatus';
import {
    RecipientStatusFromJSON,
    RecipientStatusFromJSONTyped,
    RecipientStatusToJSON,
    RecipientStatusToJSONTyped,
} from './RecipientStatus';

/**
 * 
 * @export
 * @interface UpdateRecipientStatusRequest
 */
export interface UpdateRecipientStatusRequest {
    /**
     * 
     * @type {RecipientStatus}
     * @memberof UpdateRecipientStatusRequest
     */
    status: RecipientStatus;
}



/**
 * Check if a given object implements the UpdateRecipientStatusRequest interface.
 */
export function instanceOfUpdateRecipientStatusRequest(value: object): value is UpdateRecipientStatusRequest {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function UpdateRecipientStatusRequestFromJSON(json: any): UpdateRecipientStatusRequest {
    return UpdateRecipientStatusRequestFromJSONTyped(json, false);
}

export function UpdateRecipientStatusRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateRecipientStatusRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'status': RecipientStatusFromJSON(json['status']),
    };
}

export function UpdateRecipientStatusRequestToJSON(json: any): UpdateRecipientStatusRequest {
    return UpdateRecipientStatusRequestToJSONTyped(json, false);
}

export function UpdateRecipientStatusRequestToJSONTyped(value?: UpdateRecipientStatusRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': RecipientStatusToJSON(value['status']),
    };
}

